import React, { useEffect, useState } from "react";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import { Tab, TabList, Tabs } from "react-tabs";
import { useGetFetch, useGetFetchNew } from "../../../data/Queries";
import { top_gyms } from "../../../data/ApiEndpoints";
import { convertThenFormat } from "../../../components/common-data/Converts";
import Modal from "react-modal";
import TopGymDetail from "./TopGymDetail";

const TopGyms = ({ userInfoData, gymId }) => {
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(8);
  const [activeTab, setActiveTab] = useState("spent");
  const [selectedGym, setSelectedGym] = useState(null);

  // Fetch Data with Filters
  const { data, isLoading, refetch } = useGetFetchNew({
    token: userInfoData?.token,
    key: "top_gyms",
    url: `${top_gyms}`,
    filters: {
      limit: pageLimit,
      gym_id: gymId || "",
      page: page + 1,
    },
  });

  useEffect(() => {
    refetch();
  }, [gymId]);

  // Define columns
  const baseColumns = [
    {
      dataField: "gym_name",
      text: <p className="table__header">Gym Name</p>,
      formatter: (cell, row) => (
        <p
          onClick={() => setSelectedGym(row)}
          style={{
            cursor: "pointer",
            color: "blue",
            textDecoration: "underline",
          }}
        >
          {row?.gym_name}
        </p>
      ),
    },
  ];

  const earnColumn = {
    dataField: "total_earn",
    text: <p className="table__header">Total Coins Earned</p>,
    formatter: (cell, row) => (
      <div>
        <p style={{ fontSize: "18px" }}>{row?.total_earn}</p>
        <p>{`₹${convertThenFormat(row?.total_earn_inr_value)}`}</p>
      </div>
    ),
  };

  const spentColumn = {
    dataField: "total_spent",
    text: <p className="table__header">Total Coins Spent</p>,
    formatter: (cell, row) => (
      <div>
        <p style={{ fontSize: "18px" }}>{row?.total_spent}</p>
        <p>{`₹${convertThenFormat(row?.total_spent_inr_value)}`}</p>
      </div>
    ),
  };

  // Set columns dynamically based on activeTab
  const tbColumns =
    activeTab === "spent"
      ? [...baseColumns, spentColumn]
      : [...baseColumns, earnColumn];

  return (
    <div className="allEarningTask">
      <div className="flex-container">
        <h4>Top Gyms</h4>

        <div className="tab__Border">
          <Tabs
            onSelect={(index) =>
              setActiveTab(index === 0 ? "spent" : index === 1 ? "earn" : "")
            }
          >
            <TabList
              style={{
                margin: 0,
                padding: 0,
              }}
            >
              <Tab>Spend</Tab>
              <Tab>Earning</Tab>
            </TabList>
          </Tabs>
        </div>
      </div>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        <PaymentLinkTable
          tableData={data?.data}
          tableColumns={tbColumns}
          userInfoData={userInfoData}
          isPage={page}
          setIsPage={(value) => setPage(value)}
          isLoading={isLoading}
          tablePagination={data?.pagination}
          setPageLimit={setPageLimit}
          pageLimit={pageLimit}
        />
      </div>

      <Modal
        isOpen={selectedGym != null}
        contentLabel="Gym Reward Details"
        ariaHideApp={false}
        onRequestClose={() => setSelectedGym(null)}
      >
        <TopGymDetail
          closeModal={() => setSelectedGym(null)}
          selectedGym={selectedGym}
          userInfoData={userInfoData}
          gymId={gymId}
        />
      </Modal>
    </div>
  );
};

export default TopGyms;
